import type { BlockedCause, HomeChannel, MissingStep } from '../../api';
import { channelSettingsPath } from '../settings';

/**
 * Screens Home links to (M1 §5.3). Proposal, to be validated: the router has the four tabs and
 * E7 (M2); the other paths fall back to Home until their tasks add them.
 */
export const homeLinks = {
  /** E10 · M4 */
  emergencyStop: '/emergency-stop',
  /** E8 · M5 */
  positions: '/positions',
  /** E12 · S9 */
  channels: '/channels',
  /** E11 · S8 */
  account: '/account',
  /** E7 · M2 */
  channelSettings: channelSettingsPath,
  /** E2 · S4 */
  telegramLogin: '/onboarding/telegram',
  /** E3 · S5 */
  chooseChannels: '/onboarding/channels',
  /** E4 · S6 */
  tradingAccount: '/onboarding/trading-account',
} as const;

/**
 * Where each missing step sends the trader (FXM-01 §5 "what is missing"). `configure_channel`
 * opens the first channel that is not set up, as on AccueilIncomplet.
 */
export function linkForMissingStep(step: MissingStep, channels: readonly HomeChannel[]): string {
  switch (step) {
    case 'telegram_login':
      return homeLinks.telegramLogin;
    case 'choose_channel':
      return homeLinks.chooseChannels;
    case 'connect_trading_account':
      return homeLinks.tradingAccount;
    case 'configure_channel': {
      const first = channels.find((channel) => channel.copyState === 'to_configure');
      return first === undefined
        ? homeLinks.channels
        : homeLinks.channelSettings(first.subscriptionId);
    }
  }
}

/** Where each blocking cause sends the trader (FXM-01 §6 case 6: Home says what to do). */
export function linkForBlockedAction(action: BlockedCause['action']): string {
  switch (action) {
    case 'reidentify_telegram':
      return homeLinks.telegramLogin;
    case 'reconnect_trading_account':
      return homeLinks.tradingAccount;
  }
}
